import { Component } from '@angular/core';

/** The dark top bar of the public inquiry form: logo and the three promises. */
@Component({
  selector: 'app-inquiry-header',
  templateUrl: './inquiry-header.component.html',
})
export class InquiryHeaderComponent {
}
